import { StarIcon } from "@chakra-ui/icons";
import { Flex, Text, Box } from "@chakra-ui/react";
import React from "react";

const TestimonialCard = ({ title, testimony, name, last }) => {
  return (
    <Box width={{ base: "unset", md: "33%" }}>
      <Flex
        borderWidth={"1px"}
        p={{ base: "15px", md: "46px" }}
        alignItems={"center"}
        flexDir={"column"}
        width={{ base: "312px", md: "100%" }}
        bg={"white"}
        mr={{ base: last ? 0 : "15px", md: 0 }}
        justifyContent={"space-between"}
        height={"100%"}
      >
        <Flex alignItems={"center"} flexDir={"column"}>
          <Flex flexDir={"row"}>
            {Array(5)
              .fill("")
              .map((_, i) => (
                <StarIcon
                  mr={i === 4 ? "0" : "1"}
                  color={"brand.800"}
                  key={i}
                />
              ))}
          </Flex>
          <Text
            mt={"20px"}
            textAlign={"center"}
            mb={"15px"}
            fontSize={"18px"}
            fontWeight={"500"}
            lineHeight={"24px"}
          >
            “{title}”
          </Text>
          <Text
            mb={"44px"}
            textAlign={"center"}
            fontSize={"15px"}
            fontWeight={"500"}
            lineHeight={"26px"}
            color={"gray.500"}
          >
            {testimony}
          </Text>
        </Flex>
        <Text
          fontSize={"15px"}
          textAlign={"center"}
          lineHeight={"17px"}
          fontWeight={"500"}
        >
          - {name}
        </Text>
      </Flex>
    </Box>
  );
};

export { TestimonialCard };
